<template>
  <div class="info-panel" v-show="visible">
    <div class="info-title">
      <span class="info-title--prefix"></span>
      <span class="info-title--content">详情</span>
      <a-icon type="close" class="info-title--sufix" @click="close" />
    </div>
    <div class="info-content">
      <div class="info-content-item" v-for="item in infoData" :key="item.id">
        <span class="info-content-item-name">{{ item.name }}:</span>
        <span v-if="item.hyperlinkUrl" class="info-content-item-value-hyperlink" @click="handleHyperlink(item)">
          {{ item.value }}
        </span>
        <span v-else-if="item.clickable" class="info-content-item-value-clickable" @click="handleClickableField(item)">
          {{ item.value }}
        </span>
        <span v-else class="info-content-item-value">
          {{ item.value }}
        </span>
      </div>
      <div v-if="infoData.length === 0" class="no-data">暂无配置详情</div>
    </div>

    <div v-if="currentType === 'gis_pipe_line' || currentType.startsWith('gis_pipe_network')" class="info-footer">
      <a-button v-if="currentType.startsWith('gis_pipe_network')" type="link" size="small" class="move-btn"
        @click="handleMove"><a-icon :type="isMovingPoint ? 'close-circle' : 'environment'" />{{ isMovingPoint ? '取消移动' :
          '移动点' }}</a-button>
      <a-button type="link" size="small" class="edit-btn" @click="handleEdit"><a-icon type="edit" />编辑</a-button>
      <a-button type="link" size="small" class="delete-btn" @click="handleDelete"><a-icon type="delete" />删除</a-button>
    </div>

    <water-number-modal ref="WaterNumberModal" style="z-index: 9999;"></water-number-modal>
  </div>
</template>

<script>
import { getFeatureConfig, valveTypes } from '../../../mapModule/featureConfig.js'
import WaterNumberModal from '../../../WaterNumberModal'

export default {
  name: 'InfoPanel',
  components: {
    WaterNumberModal
  },
  props: {
    mappingTable: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
      infoData: [],
      currentProperties: null,
      currentType: '',
      isMovingPoint: false
    }
  },
  methods: {
    /**
     * 显示并加载数据
     * @param {Object} properties - 要素属性数据
     * @param {String} type - 要素类型 (gis_pipe_line 或 gis_pipe_network)
     */
    show (properties, type) {
      console.log('显示详情面板:', type, properties);
      this.currentProperties = properties;

      let refinedType = type;
      // 如果是物探点，尝试从 MappingTable 获取更精确的配置类型
      if (type === 'gis_pipe_network') {
        const pointTypeName = properties.point || properties.featurePoint || properties.appendage || properties.structure;
        if (pointTypeName && this.mappingTable[pointTypeName]) {
          refinedType = this.mappingTable[pointTypeName].config || refinedType;
        }
      }

      this.currentType = refinedType;
      this.visible = true;

      // 根据要素类型获取配置
      const config = getFeatureConfig(refinedType);
      if (config) {
        this.handleFeature(properties, config);
      } else {
        this.infoData = [];
      }
    },

    // 处理要素数据映射到显示列表
    handleFeature (data, elements) {
      this.infoData = elements.map(item => {
        const camelId = this.toCamelCase(item.id);
        let rawValue = '暂无数据';

        // 优先匹配原 ID，匹配不到则尝试匹配驼峰 ID
        if (data[item.id] !== undefined && data[item.id] !== null) {
          rawValue = data[item.id];
        } else if (data[camelId] !== undefined && data[camelId] !== null) {
          rawValue = data[camelId];
        }

        let displayValue = rawValue;
        let hyperlinkUrl = '';

        // 应用格式化规则
        if (item.rule && rawValue !== '暂无数据') {
          displayValue = this.formatValue(rawValue, item.rule);
        }

        // 构建超链接URL
        if (item.hyperlink) {
          hyperlinkUrl = this.buildHyperlinkUrl(item.hyperlink, data);
        }

        // 处理可点击字段
        let clickableConfig = item.clickable;
        if (clickableConfig && typeof clickableConfig === 'object') {
          if (item.id === 'start_class_no' || item.id === 'end_class_no' || item.id === 'class_no') {
            clickableConfig = {
              ...clickableConfig,
              value: rawValue
            };
          } else if (clickableConfig.type) {
            const clickCamelId = this.toCamelCase(clickableConfig.type);
            clickableConfig = {
              ...clickableConfig,
              value: data[clickableConfig.type] || data[clickCamelId] || ''
            };
          }
        }

        return {
          ...item,
          value: displayValue,
          hyperlinkUrl: hyperlinkUrl,
          clickable: clickableConfig
        };
      });
    },

    formatValue (value, rule) {
      if (rule.position === 'before') {
        return rule.text + value;
      } else if (rule.position === 'after') {
        return value + rule.text;
      }
      return value;
    },

    buildHyperlinkUrl (hyperlink, data) {
      let url = hyperlink.url;
      hyperlink.value.forEach(fieldName => {
        const camelFieldName = this.toCamelCase(fieldName);
        const fieldValue = data[fieldName] || data[camelFieldName] || '';
        url = url.replace(/=([^&]*)/, '=' + fieldValue);
      });
      return url;
    },

    handleHyperlink (item) {
      if (item.hyperlink.way === 'open') {
        window.open(item.hyperlinkUrl);
      }
    },

    handleClickableField (item) {
      console.log('点击了可点击字段:', item);
      switch (item.id) {
        case 'water_count':
          this.handleWaterCountClick(item);
          break;
        case 'start_class_no':
        case 'end_class_no':
          this.handlePipeLineClassNoClick(item);
          break;
        case 'class_no':
          this.handlePipeNetworkClassNoClick(item);
          break;
      }
    },

    handleWaterCountClick (item) {
      const classNo = item.clickable?.value || '';
      this.$refs.WaterNumberModal.edit(classNo)
    },

    handlePipeLineClassNoClick (item) {
      const classNo = item.value || '';
      if (!classNo || classNo === '暂无数据') {
        this.$message.warning('该分类编码暂无数据');
        return;
      }
      this.$router.push({
        path: '/pipe-network/gis-pipe-line/index',
        query: { classNo: classNo, autoSearch: true }
      });
    },

    handlePipeNetworkClassNoClick (item) {
      const classNo = item.value || '';
      if (!classNo || classNo === '暂无数据') {
        this.$message.warning('该分类编码暂无数据');
        return;
      }
      this.$router.push({
        path: '/pipe-network/gis-pipe-network/index',
        query: { classNo: classNo, autoSearch: true }
      });
    },

    close () {
      this.visible = false;
      this.isMovingPoint = false;
      this.$emit('close');
      this.$emit('move-cancel');
    },

    /**
     * 处理移动点操作
     */
    handleMove () {
      this.isMovingPoint = !this.isMovingPoint;
      console.log('点击移动点:', this.currentProperties, '状态:', this.isMovingPoint);
      if (this.isMovingPoint) {
        this.$emit('move-start', this.currentProperties);
      } else {
        this.$emit('move-cancel');
      }
    },

    /**
     * 处理编辑操作
     */
    handleEdit () {
      this.isMovingPoint = false;
      console.log('点击编辑:', this.currentProperties);
      this.$emit('edit', this.currentProperties);
    },

    /**
     * 处理删除操作
     */
    handleDelete () {
      console.log('点击删除:', this.currentProperties);
      this.$emit('delete', this.currentProperties);
    },

    /**
     * 将下划线命名转换为驼峰命名
     * @param {String} str - 下划线命名的字符串
     * @returns {String} - 驼峰命名的字符串
     */
    toCamelCase (str) {
      return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
    }
  }
}
</script>

<style lang="less" scoped>
.info-panel {
  position: absolute;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  top: 10px;
  right: 10px;
  z-index: 1002;
  width: 240px;
  color: #333;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;

  .info-title {
    padding: 8px 12px;
    border-bottom: 1px solid #eee;
    display: flex;
    height: 36px;
    align-items: center;
    font-weight: bold;

    .info-title--prefix {
      width: 3px;
      height: 14px;
      background-color: #409EFF;
      margin-right: 8px;
    }

    .info-title--content {
      flex: 1;
      font-size: 14px;
      color: #333;
    }

    .info-title--sufix {
      cursor: pointer;
      font-size: 14px;
      color: #999;
      transition: all 0.3s;

      &:hover {
        transform: rotate(90deg);
        color: #ff4d4f;
      }
    }
  }

  .info-content {
    padding: 8px 0;
    max-height: 400px;
    overflow-y: auto;
    flex: 1;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 2px;
    }

    .info-content-item {
      padding: 6px 12px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
      font-size: 13px;
      transition: background 0.3s;

      &:hover {
        background: rgba(64, 158, 255, 0.05);
      }
    }

    .info-content-item-name {
      color: #666;
      white-space: nowrap;
    }

    .info-content-item-value {
      text-align: right;
      word-break: break-all;
      color: #333;
    }

    .info-content-item-value-hyperlink {
      color: #409EFF;
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: #66b1ff;
      }
    }

    .info-content-item-value-clickable {
      color: #52c41a;
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: #73d13d;
      }
    }

    .no-data {
      text-align: center;
      padding: 20px 0;
      color: #999;
      font-size: 13px;
    }
  }

  .info-footer {
    padding: 8px 12px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    background: #fafafa;
    border-radius: 0 0 4px 4px;

    .move-btn {
      color: #faad14;

      &:hover {
        color: #ffc53d;
      }
    }

    .edit-btn {
      color: #409EFF;

      &:hover {
        color: #66b1ff;
      }
    }

    .delete-btn {
      color: #ff4d4f;

      &:hover {
        color: #ff7875;
      }
    }

    :deep(.ant-btn-link) {
      padding: 0 8px;
      height: 24px;
      font-size: 13px;
      display: flex;
      align-items: center;

      // 覆盖 Ant Design 默认的图标与文字间距 (从 8px 改为 4px)
      &>.anticon+span,
      &>span+.anticon {
        margin-left: 4px !important;
      }

      .anticon {
        margin-right: 0px; // 既然上面设置了 margin-left，这里清空右边距避免双重间距
      }
    }
  }
}
</style>
